export default __webpack_public_path__ + "static/media/Section3-img-col-esq.65d06bdf.jpg";